
<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="col-10">
            <table class="table table-primary table-striped">
                <thead>
                    <tr>
                        <th>Gateau</th>
                        <th>Prix</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let chaqueGateau of lePanier">
                        <td>{{chaqueGateau.nom | classeAmericaine | uppercase}}</td>
                        <td>{{chaqueGateau.prix | currency:'EUR':true:'1.2-2'}}</td>
                        <td> <button 
                                (click)="enleverDuPanier(chaqueGateau)"
                                class="btn btn-danger">
                            <strong>X</strong></button></td>
                    </tr>
                
                    <tr>
                        <td></td>
                        <td><strong>Total</strong></td>
                        <td><strong>{{ calculDuTotal() | currency:'EUR' }}</strong></td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>


</div>